import React, { useContext } from "react";
import { LayoutContext } from "./context/layoutcontext";

const AppFooter = ({ version }) => {
  const { layoutConfig } = useContext(LayoutContext);

  return (
    <div className="layout-footer">
      {/* <img src={`/layout/images/logo-${layoutConfig.colorScheme === 'light' ? 'dark' : 'white'}.svg`} alt="Logo" height="20" className="mr-2" />
            by */}
      <span className="font-medium ml-2">
        © microva.id <strong>Ver. {version}</strong>
      </span>
    </div>
  );
};

export default AppFooter;
